import type { JSX, PropsWithChildren } from 'react';

import {
	PetitionDetailsPageDataContextProvider,
	PetitionDetailsPageUserDataContextProvider,
} from 'src/app/pages/petitionDetails/pageContext';

import { PetitionStatsStateProvider } from '../../../hooks/petitionStats';

import type { MobileModalContext } from './types';

export function MobileModalContextDecorator({
	stats,
	pageData,
	pageUserData,
	children,
}: PropsWithChildren<MobileModalContext>): JSX.Element {
	return (
		<PetitionStatsStateProvider value={stats}>
			<PetitionDetailsPageDataContextProvider pageData={pageData}>
				<PetitionDetailsPageUserDataContextProvider pageUserData={pageUserData}>
					{children}
				</PetitionDetailsPageUserDataContextProvider>
			</PetitionDetailsPageDataContextProvider>
		</PetitionStatsStateProvider>
	);
}
